import {
    type DeleteAnnouncementResponseType,
    type DeleteAnnouncementRequestType
} from "./type";
import {
    request
} from "../request";

const DeleteAnnouncement = async (params: DeleteAnnouncementRequestType): Promise<DeleteAnnouncementResponseType> => {
    return await request<DeleteAnnouncementResponseType>("/announcement/deleteAnnouncement", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default DeleteAnnouncement;
